<template>
	<div class="wages">
        <el-card>
            <span>项目公司：  </span>
            <el-select v-model="search.org" placeholder="车辆使用公司" style="width:180px;" clearable>
                <el-option label="苍南华统" value="苍南华统"></el-option>
                <el-option label="东阳康优" value="东阳康优"></el-option>
                <el-option label="海宁华统" value="海宁华统"></el-option>
                <el-option label="湖北蕙民" value="湖北蕙民"></el-option>
                <el-option label="湖州华统" value="湖州华统"></el-option>
                <el-option label="绩溪屠宰" value="绩溪屠宰"></el-option>
                <el-option label="建德政新" value="建德政新"></el-option>
                <el-option label="金华江北" value="金华江北"></el-option>
                <el-option label="缙云屠宰" value="缙云屠宰"></el-option>
                <el-option label="九江浔成" value="九江浔成"></el-option>
                <el-option label="兰溪丽农" value="兰溪丽农"></el-option>
                <el-option label="丽水华统" value="丽水华统"></el-option>
                <el-option label="路桥华统" value="路桥华统"></el-option>
                <el-option label="浦江六和" value="浦江六和"></el-option>
                <el-option label="衢州民心" value="衢州民心"></el-option>
                <el-option label="邵阳华统" value="邵阳华统"></el-option>
                <el-option label="临安华统" value="临安华统"></el-option>
                <el-option label="苏州华统" value="苏州华统"></el-option>
                <el-option label="台州华统" value="台州华统"></el-option>
                <el-option label="天台华统" value="天台华统"></el-option>
                <el-option label="仙居广信" value="仙居广信"></el-option>
                <el-option label="义乌本部" value="义乌本部"></el-option>
                <el-option label="越秀华统" value="越秀华统"></el-option>
                <el-option label="梨树华统" value="梨树华统"></el-option>
            </el-select>


            <span >员工： </span>
            <el-input style="width:100px" v-model="search.name" placeholder="姓名" clearable ></el-input>
            <el-button type="primary" icon="el-icon-search" @click="getList()" style="margin-left:20px">搜索</el-button>

            <el-button type="success" @click="add()" size="mini" style="margin-bottom:20px" icon="el-icon-circle-plus-outline">添加</el-button>
           
            <el-dialog
                title="工资维护"
                :visible.sync="dialogVisible"
                width="400px">

                <el-row>
                    <el-col :span="6"><span>项目公司</span></el-col>
                    <el-col :span="18">
                        <el-select v-model="list.org" placeholder="项目公司" style="width: 100%;" >
                            <el-option label="苍南华统" value="苍南华统"></el-option>
                            <el-option label="东阳康优" value="东阳康优"></el-option>
                            <el-option label="海宁华统" value="海宁华统"></el-option>
                            <el-option label="湖北蕙民" value="湖北蕙民"></el-option>
                            <el-option label="湖州华统" value="湖州华统"></el-option>
                            <el-option label="绩溪屠宰" value="绩溪屠宰"></el-option>
                            <el-option label="建德政新" value="建德政新"></el-option>
                            <el-option label="金华江北" value="金华江北"></el-option>
                            <el-option label="缙云屠宰" value="缙云屠宰"></el-option>
                            <el-option label="九江浔成" value="九江浔成"></el-option>
                            <el-option label="兰溪丽农" value="兰溪丽农"></el-option>
                            <el-option label="丽水华统" value="丽水华统"></el-option>
                            <el-option label="路桥华统" value="路桥华统"></el-option>
                            <el-option label="浦江六和" value="浦江六和"></el-option>
                            <el-option label="衢州民心" value="衢州民心"></el-option>
                            <el-option label="邵阳华统" value="邵阳华统"></el-option>
                            <el-option label="临安华统" value="临安华统"></el-option>
                            <el-option label="苏州华统" value="苏州华统"></el-option>
                            <el-option label="台州华统" value="台州华统"></el-option>
                            <el-option label="天台华统" value="天台华统"></el-option>
                            <el-option label="仙居广信" value="仙居广信"></el-option>
                            <el-option label="义乌本部" value="义乌本部"></el-option>
                            <el-option label="越秀华统" value="越秀华统"></el-option>
                            <el-option label="梨树华统" value="梨树华统"></el-option>
                            <el-option label="黄山华徽" value="黄山华徽"></el-option>
                        </el-select>
                    </el-col>
                </el-row>

                <el-row>
                    <el-col :span="6"><span>员工姓名</span></el-col>
                    <el-col :span="18">
                        <el-input size="mini" v-model="list.name" placeholder="员工姓名"></el-input>
                    </el-col>
                </el-row>

                <el-row>
                    <el-col :span="6"><span>类型</span></el-col>
                    <el-col :span="18">
                        <el-select v-model="list.type" placeholder="类型" style="width: 100%;" >
                            <el-option label="驾驶员" value="驾驶员"></el-option>
                            <el-option label="配送员" value="配送员"></el-option>
                        </el-select>
                    </el-col>
                </el-row>
               
                <el-row>
                    <el-col :span="6"><span>工资社保福利</span></el-col>
                    <el-col :span="18">
                        <el-input size="mini" v-model="list.wages" placeholder="前12个月的平均数"></el-input>
                    </el-col>
                </el-row>

                <span slot="footer" class="dialog-footer">
                    <el-button @click="dialogVisible = false" size="mini">取 消</el-button>
                    <el-button type="primary" @click="submit()" size="mini">确 定</el-button>
                </span>
            </el-dialog>

            <el-table
                size="mini"
                :data="tableData"
                stripe
                height="70vh"
                id='outTable'
                border>
                <el-table-column
                    prop="create_time"
                    label="创建时间">
                </el-table-column>

                <el-table-column
                    prop="org"
                    label="公司">
                </el-table-column>

                <el-table-column
                    prop="name"
                    label="姓名">
                </el-table-column>

                <el-table-column
                    prop="type"
                    label="类型">
                </el-table-column>

                <el-table-column
                    prop="wages"
                    label="工资社保福利">
                </el-table-column>

                <el-table-column
                    prop="operate"
                    label="操作人">
                </el-table-column>

                <el-table-column label="操作" width="200">
                    <template slot-scope="scope" >
                        <el-button type="primary" size="mini" @click="edit(scope.row)" icon="el-icon-edit">修改</el-button>
                        <el-button type="danger" size="mini" @click="del(scope.row)" icon="el-icon-delete">删除</el-button>
                    </template>
                </el-table-column>

            </el-table>

        </el-card>

    </div>
</template>

<script>
    import option from "../config/option.js"
    import { staffList,staffAdd,staffEdit,staffDel} from '../router/api';
    import * as XLSX from 'xlsx';
    import FileSaver from "file-saver";

	export default{
		data(){
			return {
                list: {
                    id:'',
                    org:'',
                    name:'',
                    type:'',
                    wages:'',
                },
                search: {
                    org:'',
                    name:'',
                },
                dialogVisible:false,
                tableData:[],
                options2:[],
            }
        },
      
        mounted() {
           this.getList()
        },
		methods: {
            getList() {
                staffList({
                    id:'',
                    org:this.search.org,
                    name:this.search.name,
                }).then(res=> {
                    if(res.code==1) {
                        this.tableData = res.data
                    }
                }).catch(err=> {
                    console.log(err);
                });
            },

            submit() {
                if(this.list.org==''||this.list.name==''||this.list.type==''||this.list.wages==''){
                    this.$message.error('请填写完整信息');
                    return;
                } 
                if(this.list.id) {
                    staffEdit({
                        id: this.list.id,
                        org: this.list.org,
                        name: this.list.name,
                        type: this.list.type,
                        wages: this.list.wages,
                        operate:localStorage.getItem('ws_name'),
                    }).then(res=> {
                        if(res.code==1) {
                            this.$message.success(res.msg);
                            this.dialogVisible = false
                            this.getList()
                        } else {
                            this.$message.error(res.msg);
                        }
                    }).catch(err=> {
                        console.log(err);
                    });
                } else {
                    staffAdd({
                        org: this.list.org,
                        name: this.list.name,
                        type: this.list.type,
                        wages: this.list.wages,
                        operate:localStorage.getItem('ws_name'),
                    }).then(res=> {
                        if(res.code==1) {
                            this.$message.success(res.msg);
                            this.dialogVisible = false
                            this.getList()
                        } else {
                            this.$message.error(res.msg);
                        }
                    }).catch(err=> {
                        console.log(err);
                    });
                }
            },

            edit(row) {
                this.dialogVisible = true
                this.list =  {
                    id:row.id,
                    org: row.org,
                    name:row.name,
                    type:row.type,
                    wages:row.wages,
                }
            },

            add() {
                this.dialogVisible = true
                this.list =  {
                    id:'',
                    org: '',
                    name: '',
                    type: '',
                    wages: '',
                }
            },
            
            del(row) {
                this.$confirm('是否确定?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    staffDel({
                        id:row.id,
                    }).then(res=> {
                        this.$message.success(res.msg);
                        this.getList()
                    }).catch(err=> {
                        console.log(err);
                    });
                }).catch(() => {
                    this.$message.error('取消操作');
                });
            },
        }
    }
</script>

<style scoped="scoped" lang='less'>
    .wages  {
        .el-row {
            box-sizing: border-box;
            height: 28px;
            line-height: 28px;
            margin-bottom:10px;
        }
        /deep/ .el-dialog__body {
            padding: 10px 20px;
            color: #606266;
            font-size: 14px;
            word-break: break-all;
        }
        span {
            font-size: 12px;
        }
        .el-input {
            margin-right: 20px;
        }

        .el-select {
            width:140px;
            margin-right: 20px;
        }
        .cladmin main {
            margin-bottom: 20px;
        }
    }
</style>
